import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { UsageRightListComponent } from './usage-right-list/usage-right-list.component'

export const usageRightRoutes: Route[] = [
  {
    path: 'usage-rights',
    component: UsageRightListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'usage-rights/:id/edit',
    redirectTo: 'usage-rights/:id',
    pathMatch: 'full'
  },
  {
    path: 'usage-rights/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'UsageRight',
        nameSingular: 'Usage Right',
        namePlural: 'Usage Rights',
        path: 'usage-rights',
        slug: 'taxonomies/usage-rights',
        title: 'Usage Rights'
      }),
      permission: 'readTaxonomies'
    }
  }
]
